'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./LinesNumberRenderer');

class LinesNumberComponent extends EventEmitter {
    constructor(entityGrid, logger) {
        super();
        this._entityGrid = entityGrid;
        this._logger = logger;

        this._selected = 0;
        this._total = 0;

        this._registerListeners();
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {
        this._entityGrid.on('UpdateLinesNumber', this.setLinesNumber = this.setLinesNumber.bind(this));
    }
    _unregisterListeners() {
        this._entityGrid.removeListener('UpdateLinesNumber', this.setLinesNumber);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    get logger(){
        return this._logger;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer.shutdown()
            .then(()=>{
                this._logger = undefined;
                this._enabled = undefined;
                this._renderer = undefined;
            }, (err)=>{
                this._logger.warn(err, 'LineNumbersComponent.shutdown error');
            });
    }

    get selected() {
        return this._selected;
    }

    get total() {
        return this._total;
    }

    get enabled() {
        return this._enabled;
    }

    setLinesNumber(lines) {
        if (!lines) {
            return;
        }
        if (lines.selected !== undefined) {
            this._selected = lines.selected;
        }

        if (lines.total !== undefined) {
            this._total = lines.total;
        }

        this.emit("UpdateLinesNumber");
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = LinesNumberComponent;